export const difference = <T>(arr1: T[], arr2: T[]): T[] => {
  return arr1.filter(i => !arr2.includes(i));
}
